"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPiiMaskJson = void 0;
const default_pii_mask_json_1 = __importDefault(require("../../resources/default-pii-mask.json"));
/**
 * Default OMERS PII mask of `maskProperties` collection exported as JSON
 */
exports.defaultPiiMaskJson = default_pii_mask_json_1.default;
//# sourceMappingURL=mask.js.map